import { CLASS_NAMES, SELECTORS, EVENTS } from '@bs/constants';
import { MessageBus } from '@bs/utils';

/**
 * A class for handling the Country Sidebar height adjustment
 */
export default class CountrySidebarHeight extends MessageBus {
  /**
   * Constructor function of the CountrySidebarHeight class
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    super();
    this.element = element;

    // Initialize the view
    this.init();
  }

  /**
   * Initializes the view by calling necessary setup functions
   * @returns {object} CountrySidebarHeight A reference to the current instance
   * @chainable
   */
  init() {
    if (!document.querySelector('.country-intro')) {
      return undefined;
    }
    this.cacheDomReferences().setupHandlers().enable();
    this.adjustFooterMargin();
    return this;
  }

  /**
   * Cache DOM References
   *
   * Find all necessary DOM elements used in the view and cache them
   * @returns {object} CountrySidebarHeight A reference to the current instance
   * @chainable
   */
  cacheDomReferences() {
    this.sidebarWrap = this.element.querySelector(
      `.${CLASS_NAMES.COUNTRY_SIDEBAR_WRAP}`
    );
    this.bodyTextContent = document.querySelector(
      `.${CLASS_NAMES.BODY_TEXT_CONTENT}`
    );
    this.footer = document.querySelector(`.${SELECTORS.FOOTER}`);
    this.lastSection = document.querySelector(
      `${SELECTORS.SECTION}:${SELECTORS.LAST_OF_TYPE}`
    );

    return this;
  }

  /**
   * Create event handlers to enable interaction with view
   * @returns {object} CountrySidebarHeight A reference to the current instance
   * @chainable
   */
  enable() {
    window.addEventListener(EVENTS.RESIZE, this.adjustFooterMargin.bind(this));
    return this;
  }

  /**
   * Bind event handlers with the proper context of `this`.
   * @returns {object} A reference to the current instance
   * @chainable
   */
  setupHandlers() {
    this.adjustFooterMargin = this.adjustFooterMargin.bind(this);
    return this;
  }

  /**
   * Adjusts the footer margin when the sidebar is taller than the body text
   */
  adjustFooterMargin() {
    if (!this.sidebarWrap || !this.bodyTextContent || !this.lastSection) return;

    const sidebarHeight = this.sidebarWrap.offsetHeight;
    const bodyTextHeight = this.bodyTextContent.offsetHeight;
    const isBodyTextSection = this.lastSection.classList.contains(
      `${SELECTORS.BODY_TEXT}`
    );

    if (window.innerWidth >= 1200 && isBodyTextSection) {
      this.footer.style.marginTop =
        sidebarHeight > bodyTextHeight ? `${sidebarHeight / 1.3}px` : '';
    } else {
      this.footer.style.marginTop = '';
    }
  }
}
